import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import type { RouteGroup } from './types';
import ExternalLayout from 'src/layouts/v2/ExternalLayout';

const HomeSub = lazy(() => import('src/pages/v2/HomeSub'));
const LeaveTicketV2 = lazy(() => import('src/pages/v2/HrTicket/LeaveTicket'));
const AddLeaveTicketSub = lazy(() => import('src/pages/v2/Sub/AddLeaveTicket'));
const ResignationTicket = lazy(() => import('src/pages/v2/HrTicket/ResignationTicket'));
const AddResignationTicketSub = lazy(() => import('src/pages/v2/Sub/AddResignationTicket'));
const BiometricLogV2 = lazy(() => import('src/pages/v2/HrTicket/BiometricLog'));

export const subRoutes: RouteGroup = [
  {
    path: urlPath.homeSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: HomeSub,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.qrScanner.location,
    Layout: MainLayoutV2,
    Component: HomeSub
  },
  {
    path: urlPath.myLeaveTicketSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: LeaveTicketV2,
    hasSidebar: false,
    hasSubSidebar: false
  },
  {
    path: `${urlPath.myLeaveTicketSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: LeaveTicketV2,
    hasSidebar: false
  },
  {
    path: urlPath.leaveTicketAddSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: AddLeaveTicketSub,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.leaveTicketEditSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: AddLeaveTicketSub,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: urlPath.myResignationTicketSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: ResignationTicket,
    hasSidebar: false,
    hasSubSidebar: false
  },
  {
    path: `${urlPath.myResignationTicketSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: ResignationTicket,
    hasSidebar: false
  },
  {
    path: urlPath.resignationTicketAddSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: AddResignationTicketSub,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.resignationTicketEditSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: AddResignationTicketSub,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  {
    path: urlPath.biometricLogSub.location,
    Layout: MainLayoutV2,
    SubLayout: ExternalLayout,
    Component: BiometricLogV2,
    hasSidebar: false
  }
];
